/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgEntrepreneurship = (props: SVGProps<SVGSVGElement>) => (
  <svg width={29.771} viewBox="0 0 29.771 29.786" {...props}>
    <path
      data-name="Path 449"
      d="M20.769 27.644a1.7 1.7 0 01-1.7 1.7H2.155a1.7 1.7 0 01-1.7-1.7 7.77 7.77 0 017.77-7.77h4.774a7.771 7.771 0 017.77 7.77zm0 0"
      fill="#e8edf2"
    />
    <path
      data-name="Path 450"
      d="M20.769 27.644a1.7 1.7 0 01-1.7 1.7H3.736a1.7 1.7 0 01-1.7-1.7 7.77 7.77 0 017.77-7.77h3.193a7.771 7.771 0 017.77 7.77zm0 0"
      fill="#f9f9fb"
    />
    <path
      data-name="Path 451"
      d="M12.503 19.866l-1.89 3.209-1.89-3.209v-4.591h3.781zm0 0"
      fill="#e3a76f"
    />
    <path
      data-name="Path 452"
      d="M11.579 26.112h-1.9l-1 3.233h3.936zm0 0"
      fill="#12b05e"
    />
    <path
      data-name="Path 453"
      d="M11.468 26.192H9.746a.634.634 0 01-.633-.632v-1.524a.635.635 0 01.633-.632h1.722a.634.634 0 01.632.632v1.524a.634.634 0 01-.632.632zm0 0"
      fill="#12b05e"
    />
    <g data-name="Group 146" fill="#e3a76f">
      <path
        data-name="Path 454"
        d="M7.299 12.254a2.209 2.209 0 11-2.209-2.209 2.209 2.209 0 012.209 2.209zm0 0"
      />
      <path
        data-name="Path 455"
        d="M18.362 12.254a2.209 2.209 0 11-2.209-2.209 2.209 2.209 0 012.209 2.209zm0 0"
      />
      <path
        data-name="Path 456"
        d="M16.366 3.554v10.274c0 2.672-3.126 4.917-4.98 5.56a2.862 2.862 0 01-.88.184 7.061 7.061 0 01-3.474-1.683 5.6 5.6 0 01-2.386-4.061V3.554a1.9 1.9 0 011.9-1.9h7.928a1.9 1.9 0 011.9 1.9zm0 0"
      />
    </g>
    <path
      data-name="Path 457"
      d="M16.366 3.554v10.274c0 2.312-2.341 4.3-4.173 5.216a1.809 1.809 0 01-1.611 0 9.891 9.891 0 01-1.791-1.157 5.6 5.6 0 01-2.386-4.061V3.554a1.9 1.9 0 011.9-1.9h6.169a1.9 1.9 0 011.9 1.9zm0 0"
      fill="#f2bb88"
    />
    <path
      data-name="Path 458"
      d="M7.314 18.638l-1.45 1.513a.46.46 0 00-.106.458l1.316 4.147A.767.767 0 008.148 25l2.6-1.684-2.706-4.593a.46.46 0 00-.728-.085zm0 0"
      fill="#e8edf2"
    />
    <path
      data-name="Path 459"
      d="M13.905 18.638l1.45 1.513a.461.461 0 01.107.458l-1.317 4.147a.767.767 0 01-1.074.244l-2.6-1.684 2.706-4.593a.46.46 0 01.728-.085zm0 0"
      fill="#e8edf2"
    />
    <path
      data-name="Path 460"
      d="M15.807 19.417v8.336a1.59 1.59 0 001.59 1.59h10.344a1.59 1.59 0 001.59-1.59v-8.336a.857.857 0 00-.857-.857h-11.81a.857.857 0 00-.857.857zm0 0"
      fill="#7c3f2c"
    />
    <path
      data-name="Path 461"
      d="M29.331 19.417v1.177a2.5 2.5 0 01-.047.481 2.468 2.468 0 01-2.419 1.985h-8.592a2.467 2.467 0 01-2.466-2.466v-1.177a.857.857 0 01.7-.843.811.811 0 01.153-.014h11.81a.857.857 0 01.861.857zm0 0"
      fill="#ae583e"
    />
    <path
      data-name="Path 462"
      d="M29.33 19.417v1.177a2.5 2.5 0 01-.047.481 2.459 2.459 0 01-1.715.695h-8.592a2.467 2.467 0 01-2.466-2.466v-.729a.813.813 0 01.153-.014h11.81a.857.857 0 01.857.857zm0 0"
      fill="#c0694e"
    />
    <path
      data-name="Path 463"
      d="M16.919 8.053h-1.8a1.75 1.75 0 01-1.75-1.75v-3.2a1.749 1.749 0 011.75-1.749h.379a1.749 1.749 0 011.75 1.749v4.626a.325.325 0 01-.325.325zm0 0"
      fill="#3e5564"
    />
    <path
      data-name="Path 464"
      d="M15.877.739v.547s-.125 2.941-4.015 4.768c-.089.042-.208-.009-.195-.083l.246-1.321c.018-.1-.172-.136-.236-.05a14 14 0 01-4.6 4.166c-.1.045-.22-.015-.193-.092l.5-1.418c.032-.091-.138-.147-.221-.073a7.841 7.841 0 01-3.805 1.93c-.079.012-.153-.029-.153-.085V2.662C3.205 1.435 4.691.44 6.524.44h8.9c.246 0 .446.134.446.3zm0 0"
      fill="#2d4453"
    />
    <path
      data-name="Path 465"
      d="M15.43.44a7.133 7.133 0 01-3.568 3.268c-.089.042-.208-.009-.195-.083l.246-1.321c.018-.1-.172-.136-.236-.05a14 14 0 01-4.6 4.166c-.1.045-.22-.015-.193-.092l.5-1.418c.032-.091-.138-.147-.221-.073a7.842 7.842 0 01-3.805 1.93c-.079.012-.153-.029-.153-.085v-4.02C3.205 1.435 4.691.44 6.524.44zm0 0"
      fill="#3e5564"
    />
    <path
      data-name="Path 466"
      d="M25.723 24.901h1.113a.226.226 0 00.226-.226v-3.227a.226.226 0 00-.226-.225h-1.113a.226.226 0 00-.226.225v3.228a.226.226 0 00.226.225zm0 0"
      fill="#ffc14f"
    />
    <path
      data-name="Path 467"
      d="M18.303 24.901h1.113a.226.226 0 00.226-.226v-3.227a.226.226 0 00-.226-.225h-1.113a.226.226 0 00-.226.225v3.228a.226.226 0 00.226.225zm0 0"
      fill="#ffc14f"
    />
    <path
      data-name="Path 468"
      d="M27.061 23.053v1.627a.226.226 0 01-.225.226h-1.113a.226.226 0 01-.226-.226v-1.615h1.368q.099-.004.196-.012zm0 0"
      fill="#ffa90b"
    />
    <path
      data-name="Path 469"
      d="M19.642 23.061v1.619a.226.226 0 01-.225.226h-1.113a.226.226 0 01-.226-.226v-1.622q.1.008.2.008zm0 0"
      fill="#ffa90b"
    />
    <path
      data-name="Path 470"
      d="M29.331 26.064a.44.44 0 00.44-.44v-6.206a1.3 1.3 0 00-1.3-1.3h-2.458v-1.57a1.155 1.155 0 00-1.078-1.216h-4.736a1.155 1.155 0 00-1.078 1.216v1.57h-2.457a1.3 1.3 0 00-1.3 1.3v.123l-1.2-1.249a6.917 6.917 0 002.477-3.429A2.649 2.649 0 0016.78 9.7V8.5h.138a.765.765 0 00.765-.764V3.1a2.193 2.193 0 00-1.366-2.029V.739A.814.814 0 0015.432 0h-8.9C4.766 0 2.775.964 2.775 2.662v6.367a.553.553 0 00.658.519 6.053 6.053 0 00.747-.162v.381a2.649 2.649 0 00.119 5.033 4.731 4.731 0 00.317.885.442.442 0 10.8-.375c-.543-1.151-.283-1.493-.351-4.816V9.071a8.7 8.7 0 001.53-.865l-.115.321a.552.552 0 00.792.638 12.806 12.806 0 003.974-3.306.515.515 0 00.188.528.605.605 0 00.621.065q.471-.222.876-.462v.31a2.191 2.191 0 002.189 2.189h.779c.006 4.7.045 5.722-.18 6.389a6.514 6.514 0 01-2.309 2.883 9.454 9.454 0 01-1.366.862 3.648 3.648 0 01-1.567.515 7.7 7.7 0 01-4.154-2.487.44.44 0 10-.655.587 9.361 9.361 0 001.253 1.153L5.479 19.9a8.225 8.225 0 00-5.48 7.745 2.143 2.143 0 002.14 2.14h25.6a2.032 2.032 0 002.03-2.03v-.37a.44.44 0 00-.88 0v.37a1.152 1.152 0 01-1.15 1.15c-11.478 0-10.5.076-10.716 0a1.234 1.234 0 01-.778-1.15v-5.08a2.9 2.9 0 001.391.754v1.246a.666.666 0 00.666.666h1.113a.666.666 0 00.666-.666V23.5h4.975v1.175a.666.666 0 00.666.666h1.113a.666.666 0 00.666-.666V23.43a2.906 2.906 0 001.39-.754v2.949a.44.44 0 00.44.44zM4.18 13.8a1.769 1.769 0 010-3.063zm13.719-1.536a1.771 1.771 0 01-1.117 1.644v-3.289a1.771 1.771 0 011.117 1.645zm-5.67-6.888l.12-.644a.567.567 0 00-1.022-.392 15.122 15.122 0 01-3.728 3.643l.209-.583a.5.5 0 00-.2-.594.6.6 0 00-.727.044 7.62 7.62 0 01-3.226 1.763V2.662C3.655 1.7 4.973.88 6.534.88h8.9v.034a2.5 2.5 0 01-.1.88 6.057 6.057 0 01-3.112 3.582zm2.888 2.237A1.31 1.31 0 0113.805 6.3v-.9A6.366 6.366 0 0016.199 2a1.31 1.31 0 01.6 1.1v4.51zm-1.559 11.311l1.453 1.516.008.009.008.007-1.3 4.107a.338.338 0 01-.433.06l-2.246-1.455 2.506-4.252zm-1.908 5.687v.95a.2.2 0 01-.192.192H9.736a.2.2 0 01-.192-.192v-.95l1.053-.682zm.527-5.074l-1.58 2.681c-1.237-2.1-1.2-2.028-1.5-2.542a3.094 3.094 0 003.078-.139zm-6.019.928c.235-.235-.038.041 1.475-1.538l2.505 4.252c-2.477 1.6-2.336 1.543-2.518 1.5a.287.287 0 01-.161-.1l-1.3-4.107zm2.181 8.441H5.047v-2.9a.44.44 0 00-.88 0v2.9H2.14a1.262 1.262 0 01-1.26-1.261 7.341 7.341 0 014.489-6.757c1.349 4.238 1.263 4 1.3 4.08a1.207 1.207 0 001.7.4l.292-.189a1.343 1.343 0 00.443 1.247zm.92 0l.7-2.273h1.3l.74 2.273zm3.66 0l-.8-2.5a1.366 1.366 0 00.411-1.223l.292.189a1.2 1.2 0 001.733-.48l.813-2.562v5.425a2.016 2.016 0 00.36 1.153zm7.086-12.355c0-.2.119-.337.2-.337h4.731c.079 0 .2.134.2.337v1.57h-5.131zm-.8 7.91h-.685V23.5h.679zm0-1.84h-.685v-.959h.679zm7.419 1.84h-.685V23.5h.685zm0-1.84h-.685v-.959h.685zm.88-.1v-1.07a.666.666 0 00-.665-.665h-1.117a.666.666 0 00-.665.665v1.173h-4.976v-1.176a.666.666 0 00-.665-.665h-1.117a.666.666 0 00-.665.665v1.071a2.035 2.035 0 01-1.325-1.41 7.645 7.645 0 01-.066-1.691.418.418 0 01.421-.418h11.81a.418.418 0 01.417.417v1.177a2.03 2.03 0 01-1.39 1.924zm0 0"
    />
    <path
      data-name="Path 471"
      d="M12.905 12.277a.694.694 0 10.694-.694.694.694 0 00-.694.694zm0 0"
    />
    <path
      data-name="Path 472"
      d="M14.947 10.579a.44.44 0 00.235-.812 4.089 4.089 0 00-2.608-.263.44.44 0 00.18.861 4.171 4.171 0 011.544-.015c.424.1.417.229.65.229zm0 0"
    />
    <path
      data-name="Path 473"
      d="M6.901 12.277a.694.694 0 10.727-.693.694.694 0 00-.727.693zm0 0"
    />
    <path
      data-name="Path 474"
      d="M8.619 9.505a4.089 4.089 0 00-2.608.263.44.44 0 00.235.812c.234 0 .222-.131.65-.23a4.177 4.177 0 011.544.016.44.44 0 00.18-.861zm0 0"
    />
    <path
      data-name="Path 475"
      d="M11.492 15.025a.9.9 0 01-1.791 0 .441.441 0 00-.44-.44c-.926 0-.354 2.215 1.336 2.215a1.737 1.737 0 001.737-1.954.44.44 0 00-.841.179zm0 0"
    />
  </svg>
);

SvgEntrepreneurship.defaultProps = {};
export default SvgEntrepreneurship;
/* eslint-enable */
